import { useCallback, useState } from 'react';

export type ConflictField = 'displayName' | 'medicinalProductName';

export interface IDuplicateProductInfo {
  productId: string;
  productGroupId?: string;
  submissionId?: string;
  conflictingName?: string;
  conflictField?: ConflictField;
  sourceField?: ConflictField;
}

interface IProps {
  onDuplicateProductView?: (duplicateInfo: IDuplicateProductInfo) => void;
  getConflictingName: (sourceField?: ConflictField) => string | undefined;
}

export const useDuplicateProductError = ({ onDuplicateProductView, getConflictingName }: IProps) => {
  const [duplicateProductInfo, setDuplicateProductInfo] = useState<IDuplicateProductInfo | null>(null);

  const handleDuplicateError = useCallback(
    (errorMessage: IDuplicateProductInfo) => {
      const conflictingName = getConflictingName(errorMessage.sourceField)?.trim();
      setDuplicateProductInfo({ ...errorMessage, conflictingName });
    },
    [getConflictingName],
  );

  const handleDuplicateErrorClose = useCallback(() => setDuplicateProductInfo(null), []);

  const handleDuplicateProductView = useCallback(() => {
    if (onDuplicateProductView && duplicateProductInfo) {
      onDuplicateProductView(duplicateProductInfo);
      setDuplicateProductInfo(null);
    }
  }, [onDuplicateProductView, duplicateProductInfo]);

  return {
    duplicateProductInfo,
    handleDuplicateError,
    handleDuplicateErrorClose,
    handleDuplicateProductView,
  };
};
